<template>
    <main id="mainCtrl">

        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs" v-cloak>
                <li :class="{'active': defaultFilter.type === 'new'}" @click.stop.prevent="load('new')" id="tabNew"><a
                    href="#">Новые</a></li>
                <li :class="{'active': defaultFilter.type === 'published'}" @click.stop.prevent="load('published')"
                    id="tabPublished"><a href="#">Опубликованные</a></li>
                <li :class="{'active': defaultFilter.type === 'unpublished'}" @click.stop.prevent="load('unpublished')"
                    id="tabUnpublished"><a href="#">Неопубликованные</a></li>
            </ul>
        </div>
        <v-table
            id="mainTbl"
            :default-filter="defaultFilter"
            request-uri="directQuestions/getList"
            pagesize="50"
            ref="table"
            :show-eye="false"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="intervieweeName">
                        Название клиники или фио фрача
                    </v-th>
                    <v-th name="text">
                        Текст вопроса
                    </v-th>
                    <v-th name="moderatedBy">
                        Проверил
                    </v-th>
                    <v-th name="authorName">
                        Имя автора
                    </v-th>
                    <v-th name="authorPhone">
                        Телефон автора
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="intervieweeName" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>

                    <v-th name="text" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>

                    <v-th name="moderatedBy" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...userOptions.map(({text, value}) => {
                                    return {
                                        text,
                                        value
                                    }
                                })
                            ]'
                        ></v-select>
                    </v-th>

                    <v-th name="authorName" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="authorPhone" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                </v-tr>
            </template>

            <template v-slot:row="{ item, index }">
                <v-tr>
                    <v-td>
                        <FormRow :key="index" :item="item"
                                 :status="defaultFilter.type"
                                 :can-modify="canModify"
                                 :can-delete="canDelete"
                                 @update-table="$refs.table.update()" >
                            <template v-slot:legend>
                                <a :href="`${urlsFrontend}/${item.interviewee.city}/${item.interviewee_type.toLowerCase()}/${item.interviewee.url}`" target="_blank" v-tooltip="`${urlsFrontend}<br/>/${item.interviewee.city}/${item.interviewee_type.toLowerCase()}/${item.interviewee.url}`">
                                    {{item.interviewee.name}}
                                </a>
                            </template>
                        </FormRow>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>

import NewPublishedUnpublishedSwitcher from "@mixins/NewPublishedUnpublishedSwitcher";
import FormRow from "./FormRow";
export default {
    mixins: [NewPublishedUnpublishedSwitcher],
    props: {
        userOptions: {
            type: Array,
            required: true
        },
        urlsFrontend: {
            type: String,
            required: true
        }
    },

    components: {
        FormRow
    },
    mounted: function () {

    },
    computed: {
        canModify () {
            return this.$can('admin.moderation.directQuestions.update');
        },
        canDelete () {
            return this.$can('admin.moderation.directQuestions.delete');
        }
    },
    methods: {

    }
}
</script>

<style>

</style>
